define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    $resource(
      "#{RENTAPPLICATION_API_URL}/api/v1/applicationbundle/:id/",
      {id: "@id"},
      {
        get:
          cache: true
        query:
          isArray: false
          cache: true
        share:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationbundle/:id/share/",
          method: 'POST'
          params:
            id: "@id"
        group:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationbundle/group/",
          method: 'POST'
        ungroup:
          url: "#{RENTAPPLICATION_API_URL}/api/v1/applicationbundle/ungroup/",
          method: 'POST'
      }
    )



// WEBPACK FOOTER //
// ./resources/ApplicationBundle.coffee